import Button from './Button.jsx';

const ProgressBar = ({ header, onClose, progress, done, button, fn }) => {
    return (
        <div className="absolute top-[25%] left-[15%] z-50 flex h-[250px] w-[60%] flex-col rounded-md bg-[#1F2937CC] shadow-lg backdrop-blur-[10px]">
            {/* Header */}
            <div className="flex items-center justify-between px-3 py-1">
                <span className="text-xl font-bold">{done ? 'Dokončeno' : 'Nahrávání souboru'}</span>
                <div className="flex gap-2">
                    {header?.map((btn, idx) => (
                        <button
                            key={idx}
                            onClick={btn.action === 'close' ? onClose : undefined}
                            className={`rounded px-2 py-1 ${btn.action ? 'cursor-pointer hover:bg-white/20' : 'cursor-not-allowed opacity-50'}`}
                        >
                            <img src={btn.icon} alt="" className="h-6 w-6" />
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div className="flex flex-1 flex-col items-center justify-center px-6">
                <div className="relative h-12 w-full overflow-hidden rounded-full bg-gray-300 p-2">
                    <div
                        className="h-full rounded-full transition-all duration-150"
                        style={{ width: `${progress}%`, background: 'linear-gradient(90deg, #02A0DB, #016C9B)' }}
                    />
                    <span
                        className={`absolute inset-0 flex items-center justify-center text-base font-semibold transition-colors duration-300 ${progress < 50 ? 'text-gray-800' : 'text-white'}`}
                    >
                        {done ? 'Dokončeno' : `${progress}%`}
                    </span>
                </div>

                {/* Button z controlleru */}
                {done && button && (
                    <div className="mt-4 flex w-full justify-end">
                        <Button {...button} onClick={() => fn.handleAction(button.action)} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProgressBar;
